import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import LiveTvOutlinedIcon from '@mui/icons-material/LiveTvOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CurrencyRubleOutlinedIcon from '@mui/icons-material/CurrencyRubleOutlined';
import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import RecentActorsOutlinedIcon from '@mui/icons-material/RecentActorsOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import DvrOutlinedIcon from '@mui/icons-material/DvrOutlined';
import Shop2OutlinedIcon from '@mui/icons-material/Shop2Outlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import RadioOutlinedIcon from '@mui/icons-material/RadioOutlined';
import OtherHousesOutlinedIcon from '@mui/icons-material/OtherHousesOutlined';
import MarkAsUnreadOutlinedIcon from '@mui/icons-material/MarkAsUnreadOutlined';
import CastOutlinedIcon from '@mui/icons-material/CastOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';

export type ItemBaseType = {
  title: string;
  to: string;
  icon: React.ReactNode;
  keywords?: string[]
};

export type MenuBaseItem = ItemBaseType & { subItems?: ItemBaseType[] };

export type MenuItemType = {
  title: string;
  to?: string;
  icon: React.ReactNode;
  keywords?: string[]
  subItems?: MenuBaseItem[];
};

export const menuItems: MenuItemType[] = [
  {
    title: 'Рабочий стол',
    to: '/',
    icon: <DevicesOtherOutlinedIcon />
  },
  {
    title: 'Дела / Задачи',
    to: '/events/all',
    icon: <ListAltOutlinedIcon />
  },
  {
    title: 'Отчеты',
    to: '/reports/cash-balance',
    icon: <BarChartOutlinedIcon />
  },
  {
    title: 'Клиенты',
    icon: <BusinessCenterOutlinedIcon />,
    subItems: [
      { title: 'Список клиентов', to: '/clients/list-client-all', icon: <RecentActorsOutlinedIcon /> },
      { title: 'Договоры', to: '/contracts', icon: <ArticleOutlinedIcon /> },
      { title: 'Клиентские счета', to: '/client-invoices', icon: <MoveToInboxOutlinedIcon />, keywords: ['исходящие счета', 'инвойс'] },
      { title: 'Лиды', to: '/leads', icon: <InsightsOutlinedIcon /> },
      { title: 'Заявки', to: '/purchases', icon: <PostAddOutlinedIcon /> }
    ]
  },
  {
    title: 'Бухгалтерия',
    icon: <CalculateOutlinedIcon />,
    subItems: [
      { title: 'Платежные поручения', to: '/accounting', icon: <PostAddOutlinedIcon />, keywords: ['пп'] },
      { title: 'Зарплата', to: '/salary/home', icon: <CurrencyRubleOutlinedIcon /> },
      { title: 'Акты', to: '/wccs/bulk-create', icon: <FactCheckOutlinedIcon /> },
      { title: 'Входящие счета', to: '/supplier-invoices', icon: <MoveToInboxOutlinedIcon />, keywords: ['счета поставщика', 'инвойс'] }
    ]
  },
  {
    title: 'Поставщики',
    to: '/suppliers',
    icon: <ShoppingCartOutlinedIcon />
  },
  {
    title: 'СМИ и Услуги',
    icon: <LiveTvOutlinedIcon />,
    subItems: [
      { title: 'Список СМИ', to: '/media-list/list', icon: <DvrOutlinedIcon /> },
      { title: 'Отгрузки', to: '/media-list/purchases', icon: <Shop2OutlinedIcon /> },
      { title: 'Отправленные медиапланы', to: '/media-list/sent-mediaplans', icon: <MarkunreadMailboxOutlinedIcon /> },
      { title: 'Медиапланирование', to: '/media-planning', icon: <PermMediaOutlinedIcon /> }
    ]
  },
  {
    title: 'Настройки',
    icon: <SettingsOutlinedIcon />,
    subItems: [     
      { title: 'Расчётные счета', to: '/settings/accounting', icon: <AccountBalanceOutlinedIcon /> },
      { title: 'Шаблоны договоров', to: '/settings/contract-templates', icon: <ArticleOutlinedIcon /> },
      { title: 'Настройки СМИ', to: '/settings/media-types', icon: <RadioOutlinedIcon /> },   
      { title: 'Наши юр. лица', to: '/settings/our-legal-entities', icon: <AccountBalanceOutlinedIcon /> }, 
      { title: 'Формы собственности', to: '/settings/form-of-ownership', icon: <OtherHousesOutlinedIcon /> }, 
      { title: 'Род деятельности', to: '/settings/okved', icon: <BusinessCenterOutlinedIcon /> },  
      { title: 'Файлы', to: '/settings/files', icon: <SourceOutlinedIcon /> },                  
      { title: 'Почта', to: '/settings/email-parser', icon: <MarkAsUnreadOutlinedIcon /> },    
      {
        title: 'Пользователи',
        to: '/users',
        icon: <ManageAccountsOutlinedIcon />,
        subItems: [
          { title: 'Список пользователей', to: '/users', icon: <ManageAccountsOutlinedIcon /> },
          { title: 'Роли пользователей', to: '/settings/user-roles', icon: <PeopleOutlinedIcon />, keywords: ['пермиссии', 'доступ'] },
          { title: 'Отделы продаж', to: '/settings/sales-departments', icon: <Diversity3OutlinedIcon /> },
        ],
      },
      { title: 'Удаленный доступ', to: '/settings/remote-access', icon: <CastOutlinedIcon />, keywords: ['айпи'] },    
      { title: 'Доверенные IP-адреса', to: '/settings/home', icon: <StorageOutlinedIcon />, keywords: ['айпи'] },
      { title: 'Теги', to: '/settings/tags', icon: <LocalOfferOutlinedIcon /> },
      { title: 'Сервисные функции', to: '/settings/service-functions', icon: <MiscellaneousServicesOutlinedIcon /> },
      {
        title: 'География',
        to: '/geography',
        icon: <LocationOnOutlinedIcon />,
        subItems: [
          {
            title: 'Города',
            to: '/cities',
            icon: <LocationCityOutlinedIcon />
          },
          { title: 'Регионы', to: '/regions', icon: <MapOutlinedIcon /> },
          {
            title: 'Страны',
            to: '/countries',
            icon: <PublicOutlinedIcon />
          }
        ]
      }
    ]
  }
];
